// Authentication
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';
export const LOGIN_SUCCESS_DONE = 'LOGIN_SUCCESS_DONE';
export const SET_TIMEOUT_BLOCKED = 'SET_TIMEOUT_BLOCKED';

// User
export const GET_USER = 'GET_USER';
export const GET_USER_START = 'GET_USER_START';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAIL = 'GET_USER_FAIL';

export const CLEAR_USER = 'CLEAR_USER';

// Responsible Gaming
export const GET_USER_TAGS = 'GET_USER_TAGS';
export const GET_USER_TAGS_SUCCESS = 'GET_USER_TAGS_SUCCESS';
export const GET_USER_TAGS_ERROR = 'GET_USER_TAGS_ERROR';
export const SET_USER_EMAIL = 'SET_USER_EMAIL';
export const SET_USER = 'SET_USER';
